var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"menu_ingenieria"},_vm._l((_vm.items),function(item,idx){return _c('router-link',{key:item,attrs:{"to":_vm.itemRoute(idx)}},[_c('MenuButton',{key:item,attrs:{"texto":_vm.buttonText[idx],"offset":_vm.calcOffset(idx)}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }